import { AppointmentOrderItem } from '@spike/order-model';
import { FunctionComponent } from 'react';
import ItemContainer from './ItemContainer';
import AppointmentData from './UI/AppointmentData';

export interface AppointmentItemProps {
    appointmentItem: AppointmentOrderItem;
    className?: string;
}

export const AppointmentItem: FunctionComponent<AppointmentItemProps> = props => {
    return (
        <ItemContainer className={props.className}>
            <AppointmentData appointmentItem={props.appointmentItem} />
        </ItemContainer>
    );
};

export default AppointmentItem;
